import { useCallback, useState } from 'react';
import VisaApplicationFormComponent from '../components/visa-application-form.component';
import {
  VisaApplicationCreatePayload,
  VisaApplicationUpdatePayload,
} from '../types/visa-application.types';
import { useVisaApplicationCreate } from '../hooks/use-visa-application.hook';
import { message } from 'antd';
import { useNavigate } from 'react-router-dom';
import {
  extractCreateError,
  extractValidationError,
} from '../../../../../services/extract-api-error.service';
import HeaderRow from '../../../../common/HeaderRow';
import { ValidationError } from '../../../../../types/api-response.types';
import { useTranslation } from 'react-i18next';
import { WithPermissionCheck } from '../../../../auth/WithPermissionCheck';
import PageTitle from '@components/common/PageTitle';

const VisaApplicationCreateContainer = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [validationErrors, setValidationErrors] = useState<ValidationError[]>([]);

  const { mutateAsync: createVisaApplication, isPending } = useVisaApplicationCreate();

  const onFormSubmit = useCallback(
    async (
      data: VisaApplicationCreatePayload | VisaApplicationUpdatePayload,
      resetForm: () => void
    ) => {
      setValidationErrors([]);
      const createData = data as VisaApplicationCreatePayload;
      try {
        const response = await createVisaApplication(createData);
        message.success(t('crud.create.success', { entity: t('visaApplications.title') }));
        resetForm();
        navigate(`/dashboard/visa-application/${response.data.id}/update`);
      } catch (error: any) {
        const errorFields = extractValidationError(error);
        setValidationErrors(errorFields);
        const errorMessage = extractCreateError(
          error,
          t('crud.create.error', { entity: t('visaApplications.title') })
        );
        message.error(errorMessage);
      }
    },
    [createVisaApplication, navigate, t]
  );

  return (
    <>
      <PageTitle title={t('crud.create.title', { entity: t('visaApplications.title') })} />
      <HeaderRow
        title={t('crud.create.title', { entity: t('visaApplications.title') })}
        showBackButton={true}
      />
      <div className="row mt-3">
        <VisaApplicationFormComponent
          onFormSubmit={onFormSubmit}
          isLoading={isPending}
          validationErrors={validationErrors}
        />
      </div>
    </>
  );
};

export default WithPermissionCheck(VisaApplicationCreateContainer, 'visaApplication.create');
